<path
    fill="currentColor"
    d="M29.8281 27.9997H3.16146c-.73333 0-1.33334-.6035-1.33334-1.3412V14.7619c0-.7377.60001-1.3412 1.33334-1.3412.73333 0 1.33333.6035 1.33333 1.3412v10.5554H28.4948V14.7619c0-.7377.6-1.3412 1.3333-1.3412.7334 0 1.3334.6035 1.3334 1.3412v11.8966c0 .7377-.6 1.3412-1.3334 1.3412Z"
/>
<path
    fill="currentColor"
    d="M16.4548 17.8871c-.4667 0-.9333-.1207-1.36-.3755L3.09479 10.2287c-.78666-.48282-1.26667-1.34121-1.26667-2.25324 0-1.46193 1.17334-2.64221 2.61334-2.64221H28.5348c1.4533 0 2.6267 1.18028 2.6267 2.6288 0 .92544-.4934 1.78383-1.28 2.26665l-12.08 7.2829c-.4134.2548-.88.3755-1.3467.3755ZM4.61479 8.0157l11.86671 7.2024 12.04-7.28288-23.90671.08048Z"
/>
